import { FunctionComponent } from 'react';
import { StyledFormGroup } from './FormGroup.styled';
import { FormGroupProps } from './types';

export const FormGroup: FunctionComponent<FormGroupProps> = props => {
  const { children, errors = true, horizontal = false, ...rest } = props;

  return (
    <StyledFormGroup $errors={errors} $horizontal={horizontal} {...rest}>
      {children}
    </StyledFormGroup>
  );
};
